// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UFWjXDsgmjKeXose{height:100%;width:100%;display:flex;flex-direction:column;justify-content:flex-start;align-items:center}.UFWjXDsgmjKeXose .Mkah5pcB7U8g8Blm{height:264px;width:100%;margin-right:-16px;padding-top:16px}.UFWjXDsgmjKeXose .f86mwz4QukANg4kt{height:100%;display:flex;justify-content:center;align-items:center}.UFWjXDsgmjKeXose .sfysaghvR8U1Iukx{margin-top:-8px;height:100%;display:flex;justify-content:center;align-items:center}.HwJR9uflLJIfhXbW{position:absolute;display:flex;height:264px;width:100%;justify-content:center;align-items:center}.HwJR9uflLJIfhXbW .k9HesUEjp6oA6EQe{width:234px;text-align:center;z-index:1}.q0TsnkUHyZgcVFwx{display:flex;gap:16px}.q0TsnkUHyZgcVFwx .yM4ioOYu6w3qmy91{display:flex;align-items:center;gap:8px}.q0TsnkUHyZgcVFwx .yM4ioOYu6w3qmy91 .QhSYEOG154ss15mp{height:24px;min-width:150px;margin:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardBody": `UFWjXDsgmjKeXose`,
	"scatterChart": `Mkah5pcB7U8g8Blm`,
	"spinner": `f86mwz4QukANg4kt`,
	"emptyChartContainer": `sfysaghvR8U1Iukx`,
	"noDataMessage": `HwJR9uflLJIfhXbW`,
	"noMessageText": `k9HesUEjp6oA6EQe`,
	"dropdowns": `q0TsnkUHyZgcVFwx`,
	"labeledInput": `yM4ioOYu6w3qmy91`,
	"select": `QhSYEOG154ss15mp`
};
export default ___CSS_LOADER_EXPORT___;
